import moment from "moment/moment";
import { Groupe } from "./Groupe";
import { Site } from "./Site";
import DateType from "@/shared/DateType";

const FORMAT_DISPLAY = "DD/MM/YYYY";
const FORMAT_ENVOI = "YYYY-MM-DD";

export class Periode {
  public id: string = "J";
  public title: string = "Aujourd'hui";
  public p: number = 0;
}

export interface TypeRapport {
  className: string;
  localisedTitle: string;
  famille?: string;
  droitsMinimum?: string[];
  fabricResultsChoicesClass?: string;
  groupesExtraction?: string[];
  reportSenderClass?: string;
  serviceReportClass?: string;
  dttConfig?: any;
  MAX_DAYS?: number;
  MULTI_SITES?: boolean;
}

export interface LieuRapport {
  vendeur?: string;
  lSites: Site[];
  lCaisses?: string[];
}

export class RapportSimple extends DateType implements LieuRapport {
  public id: string = "0";
  public typeRapport: TypeRapport = { className: "", localisedTitle: "" };
  public lSites: Site[];
  public lCaisses?: string[] = [];
  public vendeur?: string = "";

  constructor() {
    super();
    this.lSites = [];
  }
}

export class RapportFav extends RapportSimple {
  public groupement?: Groupe[];
  public typeSite?: string = "site";

  constructor() {
    super();
    this.typeSite = "site";
    this.groupement = [];
    this.lCaisses = [];
  }
}

// tslint:disable-next-line: max-classes-per-file
export class Rapport extends RapportFav {
  public operation: string = "VENTE";
  public heureDebut: string = "12:00";
  public heureFin: string = "23:00";
  public localisation: [] = [];
  public type: string = "";
  public trancheHoraire: boolean = false;
  // public heureDebutStr: string = "";
  // public heureFinStr: string = "";
  public dateDebutDisplay: string = "";
  public dateFinDisplay: string = "";
  public dateDebutEnvoi: string = "";
  public dateFinEnvoi: string = "";
  public datesEnvoi: string[] = [];
  public format: string = "PDF";
  public tpv: string = "";
  public filtre: string = "";
  public condition: string[] = [];
  public ra: string = "";
  public isfilters: boolean = false;
  public tri: string = "";

  constructor() {
    super();
    this.dateDebutEnvoi = moment().format(FORMAT_ENVOI);
    this.dateDebutDisplay = moment().format(FORMAT_DISPLAY);
    this.dateFinEnvoi = moment().format(FORMAT_ENVOI);
    this.dateFinDisplay = moment().format(FORMAT_DISPLAY);
    this.datesEnvoi = [moment().format(FORMAT_DISPLAY)];
  }

  public setDateDebut(dd: Date) {
    this.dateDebut = dd;
    this.dateDebutEnvoi = moment(dd).format(FORMAT_ENVOI);
    this.dateDebutDisplay = moment(dd).format(FORMAT_DISPLAY);
  }
  public setDateFin(df: Date) {
    this.dateFin = df;
    this.dateFinEnvoi = moment(df).format(FORMAT_ENVOI);
    this.dateFinDisplay = moment(df).format(FORMAT_DISPLAY);
  }
  public setDates(dates: Date[]) {
    this.dates = dates;
    this.datesEnvoi = [];
    for (const index in dates) {
      if (dates.hasOwnProperty(index)) {
        this.datesEnvoi.push(moment(dates[index]).format(FORMAT_ENVOI));
      }
    }
  }

  public fromRapportFav(fav: RapportFav) {
    this.lSites = fav.lSites;
    this.typeRapport = fav.typeRapport;
    this.id = fav.id;
  }
}
